import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useQWaiterCart } from '~graphql/generated/clientGraphql';
import { CartContentProvider as SharedCartContentProvider, useCartContentCtx, useCartFetchingCtx, useCartUpdateCtx } from '~shared/segments/Cart';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Wrapper for CartContentProvider, which is a provider of cart related contexts.
 * Use `useCartContent` to access the order that the cart is rendering.
 * Use `useCartUpdate` to get the order updating functions (add/update/remove items).
 * Use `useCartFetching` to change something when some GQL operation that might update the cart is currently running.
 */
export var CartContentProvider = function CartContentProvider(_ref) {
  var children = _ref.children,
      loadOptions = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(SharedCartContentProvider, _objectSpread(_objectSpread({
    useQCart: useQWaiterCart
  }, loadOptions), {}, {
    children: children
  }));
};
export { useCartUpdateCtx, useCartContentCtx, useCartFetchingCtx };